export default __webpack_public_path__ + "static/media/Screenshot 2022-03-17 153015.4f5db037.png";